import AppCollection from './parts/AppCollections';
import Categories from './parts/Categories';
import Hero from './parts/Hero';
import NewLatest from './parts/NewLatest';
import Recommended from './parts/Recommended';
import Top from './parts/Top';

export default function GameHome() {
    return (
        <main className="main-content">
            
            <Hero />

            <Categories/>

            <Recommended />

            <AppCollection />

            <Top />

            <NewLatest />
            
        </main>
    );
}